module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/saves-strikeouts-1-bbe2d4520a045cc535b042f92817d1f8.svg";